/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureInApp
 */
export interface FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureInApp {
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureInApp
     */
    ValidateAndPay: string;
}

/**
 * Check if a given object implements the FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureInApp interface.
 */
export function instanceOfFxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureInApp(value: object): value is FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureInApp {
    if (!('ValidateAndPay' in value) || value['ValidateAndPay'] === undefined) return false;
    return true;
}

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureInAppFromJSON(json: any): FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureInApp {
    return FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureInAppFromJSONTyped(json, false);
}

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureInAppFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureInApp {
    if (json == null) {
        return json;
    }
    return {
        
        'ValidateAndPay': json['ValidateAndPay'],
    };
}

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureInAppToJSON(json: any): FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureInApp {
    return FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureInAppToJSONTyped(json, false);
}

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureInAppToJSONTyped(value?: FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureInApp | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ValidateAndPay': value['ValidateAndPay'],
    };
}

